
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/discrimination-policy",
      function () {
        return require("private-next-pages/discrimination-policy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/discrimination-policy"])
      });
    }
  